<template>
  <v-data-table
    :headers="cabeceras"
    :items="filasTabla"
    item-key="uuid"
    dense
    class="elevation-1"
  >
    <template v-if="!esVistaRevision && estadoAuditoria!=='CERRADA'" #item.acciones="{ item }">
      <v-btn icon small color="primary" @click="$emit('editar-producto', item.__producto)">
        <v-icon style="font-size: 20px">mdi-pencil-outline</v-icon>
      </v-btn>

      <v-btn icon small color="red" @click="$emit('eliminar-producto', item.__producto)">
        <v-icon style="font-size: 20px">mdi-delete-outline</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'TablaProductosGrid',

  props: {
    gridConfig: { type: Array, required: true },
    productos: { type: Array, required: true },
    esVistaRevision: { type: Boolean, required: true },
    estadoAuditoria: { type: String, required: true },
  },

  computed: {
    cabeceras() {
      const columnas = [...this.gridConfig]
        .filter(col => col.define_alcance !== false)
        .sort((a, b) => Number(a.orden) - Number(b.orden))
        .map(col => ({
          text: col.nombre,
          value: col.nombre,
          sortable: false,
        }))

      return [
        { text: 'Acciones', value: 'acciones', sortable: false },
        ...columnas,
      ]
    },

    filasTabla() {
      return (this.productos || []).map(producto => {
        const fila = {
          uuid: producto.uuid,
          __producto: producto, // 🔥 referencia real
        }

        for (const col of this.gridConfig) {
          const param = (producto.params || []).find(
            p => p?.nombre === col.nombre
          )

          fila[col.nombre] = this.formatearValor(param)
        }

        return fila
      })
    },
  },

  methods: {
    formatearValor(param) {
      if (!param) return '—'

      // prioridad clara
      if (param.displayValue !== undefined && param.displayValue !== null) {
        return param.displayValue
      }

      const v = param.valor

      if (v === null || v === undefined) return '—'

      if (Array.isArray(v)) {
        if (!v.length) return '—'
        if (typeof v[0] === 'object') {
          return v[0].nombre || v[0].texto || '—'
        }
        return v.join(', ')
      }

      if (typeof v === 'boolean') {
        return v ? 'Sí' : 'No'
      }

      if (typeof v === 'object') {
        return v.nombre || v.texto || '—'
      }

      return String(v)
    },
  },
}
</script>


<style scoped></style>
